var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unavailable-container"},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"fas fa-hourglass-half"})]),_c('span',{staticClass:"tip"},[_vm._v("抱歉，暂未开放，敬请期待... 😊")])])
}]

export { render, staticRenderFns }